export type CompetitionStatus = "upcoming" | "active" | "ended";

export function getCompetitionStatus(
  startDatetime: string,
  endDatetime: string
): CompetitionStatus {
  const now = new Date();
  if (now < new Date(startDatetime)) return "upcoming";
  if (now > new Date(endDatetime)) return "ended";
  return "active";
}
